export {};

global.l = (...args: any[]) => console.log(...args);
global.lo = (o: object, label?: string) => {
  const args = [JSON.stringify(o, null, 2)];
  if (label) args.unshift(label);
  console.log(...args);
};
